export default __webpack_public_path__ + "static/media/2408023.31509a78.webp";